import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import spinner from '../assets/spinner.svg';

const Spinner = ({ classes }) => (
  <div className={classes.root}>
    {}
    <img className={classes.image} src={spinner} title="loader" alt="spinner" />
  </div>
);

Spinner.propTypes = {
  classes: PropTypes.instanceOf(Object),
};

const styles = () => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  image: {
    width: 200,
    height: 200,
  },
});

export default withStyles(styles)(Spinner);



// WEBPACK FOOTER //
// ./src/Components/Spinner.jsx